import UserService from './service';

export * from './reqres';

export default UserService;
